/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Source_LocalInputs */



/**
* | output |
* | --- |
* | "Local Storage" |
*
* @param {Media_Import_Source_LocalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_source_local = /** @type {((inputs?: Media_Import_Source_LocalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Source_LocalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Stockage local")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lokaler Speicher")
	if (locale === "it") return /** @type {LocalizedString} */ ("Archiviazione locale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Локальное хранилище")
	if (locale === "es") return /** @type {LocalizedString} */ ("Almacenamiento local")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("本地存储")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ローカルストレージ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्थानीय भंडारण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Armazenamento local")
	return /** @type {LocalizedString} */ ("Local Storage")
});